
import React from 'react';
import { Button } from '@/components/ui/button';
import { ServerOff, Link2, RefreshCw } from 'lucide-react';
import { ActiveDirectoryConfig } from '../../system/types';

interface ConnectionActionsProps {
  adConfig: ActiveDirectoryConfig;
  editing: boolean;
  handleConnect: () => void;
  handleDisconnect: () => void;
  handleSyncNow: () => void;
}

const ConnectionActions: React.FC<ConnectionActionsProps> = ({
  adConfig,
  editing,
  handleConnect,
  handleDisconnect,
  handleSyncNow
}) => {
  return (
    <>
      {adConfig.status === 'connected' ? (
        <>
          <Button 
            variant="destructive" 
            onClick={handleDisconnect} 
            disabled={!editing}
            className="flex items-center gap-1"
          >
            <ServerOff className="h-4 w-4" />
            Disconnect
          </Button>
          <Button 
            variant="outline" 
            onClick={handleSyncNow} 
            disabled={!editing}
            className="flex items-center gap-1"
          >
            <RefreshCw className="h-4 w-4" />
            Sync Now
          </Button>
        </>
      ) : (
        <Button 
          onClick={handleConnect} 
          disabled={!editing}
          className="flex items-center gap-1"
        >
          <Link2 className="h-4 w-4" />
          Connect
        </Button>
      )}
    </>
  );
};

export default ConnectionActions;
